import { render, staticRenderFns } from "./BookingCard.vue?vue&type=template&id=4d1aaf00&scoped=true"
import script from "./BookingCard.vue?vue&type=script&lang=js"
export * from "./BookingCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1aaf00",
  null
  
)

export default component.exports